import QuerySelect from '@/common/QuerySelect';
import { ReactElement } from 'react';
import Select from '@/common/Select';
import { SelectAirportTypes } from './types';
import getAirportOptions from '@/common/SelectAirport/api/services/getAirportOptions';

const SelectAirport = ({ group, filter = (options) => options, ...props }: SelectAirportTypes.Props): ReactElement => {
  const getOptions = async () => {
    const groups = group !== undefined && group !== false;
    const options = await getAirportOptions(groups);
    const filteredOptions = filter(options);

    return filteredOptions?.map(({ id, displayName, values }) => (
      <Select.Option id={id} value={values.length === 1 ? values.at(0) : values} key={id}>
        {displayName}
      </Select.Option>
    ));
  };

  return <QuerySelect {...props} query={getOptions} />;
};

export default SelectAirport;
